export default __webpack_public_path__ + "static/media/3.86f2fcb1.jpg";